<template>
	<tabbed-page-layout class="claims" title="Skader" :pages="pages" />
</template>

<script>
    export default {
		props: ['pages']
    }
</script>

<style lang="scss">

</style>